<template>
<div id="insurance">
  <div class="container fluid" v-if="isLoaded && user.authenticated">
    <div v-if="this.insuranceinfo.responseReturned===1">
      <div class="row">
      <div class="col-md-6" v-if="this.insuranceinfo.propertyInsurance !=null">
      <h2>Property Insurance</h2>
      <p>
      <span>Policy Number:</span>  {{insuranceinfo.propertyInsurance.policyNumber}}<br>
      <span>Effective Date:</span>  {{insuranceinfo.propertyInsurance.effectiveDate | moment("MM-DD-YYYY")}}<br>
      <span>Expiration date:</span>  {{insuranceinfo.propertyInsurance.expirationDate | moment("MM-DD-YYYY")}}<br>
      </p>
      <p>
      <span>Coverage Amount:</span>  {{insuranceinfo.propertyInsurance.coverageAmount | currency}}<br>
      <span>Proof On File:</span> <span :class="hasPropertyInsuranceClass" >{{ hasPropertyInsurance }}</span><br>
      <span>Cancelled:</span>  <span v-if="insuranceinfo.propertyInsurance.cancelled" class="text-success">Yes</span><span v-else class="text-danger">No</span><br>
      </p>
      </div>
      <div class="col-md-6" v-else>
      <h2>Property Insurance</h2>
      <p>Nothing to show</p>
      </div>
      <div class="col-md-6" v-if="this.insuranceinfo.liabilityInsurance !=null">
      <h2>Liability Insurance</h2>
      <p>
      <span>Policy Number:</span>  {{insuranceinfo.liabilityInsurance.policyNumber}}<br>
      <span>Effective Date:</span>  {{insuranceinfo.liabilityInsurance.effectiveDate | moment("MM-DD-YYYY")}}<br>
      <span>Expiration date:</span>  {{insuranceinfo.liabilityInsurance.expirationDate | moment("MM-DD-YYYY")}}<br><br>
      <span>Coverage Amount:</span>  {{insuranceinfo.liabilityInsurance.coverageAmount | currency}}<br>
      <span>Proof On File:</span> <span :class="hasLiabilityInsuranceClass" >{{ hasLiabilityInsurance }}</span><br>
      <span>Cancelled:</span>  <span v-if="insuranceinfo.liabilityInsurance.cancelled" class="text-success">Yes</span><span v-else class="text-danger">No</span><br>
      </p>
      </div>
      <div class="col-md-6" v-else>
      <h2>Liability Insurance</h2>
      <p>Nothing to show</p>
      </div>
      </div>
      <b-row>
        <b-col>
          <p><strong><i>Please fax or email sufficient proof of insurance to our office by the 20th of the month to avoid a fee.</i></strong></p>
        </b-col>
      </b-row>
      <form enctype="multipart/form-data" @submit.prevent="validateBeforeSubmit">
      <div class="row">
        <div class="col-md-8">
          <label class="label"><h3>Upload a new Certificate of Insurance</h3></label>
          <p class="fileUploadText">File types allowed are JPG, PDF and PNG up to 5mb in size.</p>
          <p class="control has-icon has-icon-right">
            <input name="checkupload" id="files" ref="files" v-on:change="handleFilesUpload()" v-validate="'required|ext:jpeg,jpg,png,pdf'" :class="{'input': true, 'is-danger': errors.has('checkupload') }" type="file" placeholder="Attach Image">
          </p>
        </div>
      </div>
      <div class="row">
          <div class="col">
            <b-form-group label="What kind of Insurance Certificates are you sending for review?">
              <b-form-radio-group v-model="insuranceType.SelectedRadial" name="Insurance Types">
              <b-form-radio v-for="(results, index) in insuranceinfo.radialOptions" :key="index" :value="results.hiddenValue">{{results.displayText}}</b-form-radio>
              </b-form-radio-group>
          </b-form-group>
          </div>
        </div>
      <div class="row">
        <div class="col-md-6">
          <p class="control">
            <button class="btn btn-primary" type="submit">Submit</button>
          </p>
        </div>
        <div class="col-md-4" v-if="loading">
            <socket></socket>
          </div>
      </div>
      </form>
    </div>
    <div v-else-if="this.insuranceinfo.responseReturned===2">
      <div class="row">
      <div class="col-md-12">
      <h2>Please contact ALI for your insurance inquiries.</h2>
      <p>
      <span>Insurance Email:</span>  {{insuranceinfo.insuranceCertificateEmail}}<br>
      <span>Customer Service Email:</span>  {{insuranceinfo.customerServiceEmail}}<br>
      <span>Fax:</span>  {{insuranceinfo.fax}}<br>
      <span>Alternative Fax:</span>  {{insuranceinfo.alternateFax}}<br>
      <span>Phone:</span>  {{insuranceinfo.phoneNumber}}<br>
      </p>
      </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
      <div class="col-md-12">
      <h5>Please Contact Customer Service for More Information</h5>
      </div>
      </div>
    </div>
  </div>
  <div class="container fluid" v-if="message != ''">
      <div class='row'>
        <div class='col' >
          <h3 :class='sentClass'>{{message}}</h3>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import auth from './auth'
export default {
  name: 'modalInsurance',
  props: {
    parentData: {
      type: Number
    },
    modalinsuranceid: {
      type: String
    },
    startClass: {
      typle: String
    }
  },
  data: function () {
    return {
      insuranceinfo: {
        responseReturned: 'nothing'
      },
      files: '',
      message: '',
      sentClass: '',
      timer: '',
      loading: false,
      user: auth.user,
      insuranceType: {
        SelectedRadial: ''
      },
      propertyInsurance: '',
      liabilityInsurance: '',
      insuranceClass: '',
      anyDataAtAll: true,
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let formData = new FormData()
          /*
          Iteate over any file sent over appending the files
          to the form data.
          */
          for (var i = 0; i < this.files.length; i++) {
            let file = this.files[i]
            formData.append('files', file)
          }
          formData.append('json', JSON.stringify(this.insuranceType))
          this.loading = true
          // Data is valid, so we can submit the form.
          let uri = this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/insurances/insuranceemail'
          axios.post(uri, formData, {headers: auth.getAuthHeader()}).then((response) => {
            this.message = 'Thank you, your Insurance Certificate will be reviewed as soon as possible'
            if (this.insuranceType.SelectedRadial === 'Both') {
              this.propertyInsurance = 2
              this.liabilityInsurance = 2
            } else if (this.insuranceType.SelectedRadial === 'Liability') { this.liabilityInsurance = 2 } else { this.propertyInsurance = 2 }
            this.loading = false
            this.timer = setTimeout(() => {
              this.clearData()
            }, 10000)
          }).catch(() => {
            this.loading = false
            this.sentClass = 'text-danger'
            this.message = 'Something went wrong please try again later.'
            this.timer = setTimeout(() => { this.clearData() }, 10000)
          })
        }
      })
    },
    handleFilesUpload () {
      this.files = this.$refs.files.files
    },
    clearData () {
      this.message = ''
      this.loading = false
      this.$validator.pause()
      this.$nextTick(() => {
        this.$refs.files.value = ''
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    }
  },
  mounted: function () {
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/insurances', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.insuranceinfo = response.data
        if (this.insuranceinfo.propertyInsurance != null) { this.propertyInsurance = this.insuranceinfo.propertyInsurance.proofOnFile }
        if (this.insuranceinfo.liabilityInsurance != null) { this.liabilityInsurance = this.insuranceinfo.liabilityInsurance.proofOnFile }
      })
  },
  computed: {
    isLoaded: function () {
      if (this.hasOwnProperty('insuranceinfo') &&
      this.insuranceinfo != null) {
        return true
      }
      return false
    },
    hasPropertyInsurance: function () {
      if (this.propertyInsurance === 0) { return 'No' } else if (this.propertyInsurance === 1) { return 'Yes' } else { return 'In Review' }
    },
    hasPropertyInsuranceClass: function () {
      if (this.propertyInsurance === 0) { return 'text-danger' } else if (this.propertyInsurance === 1) { return 'text-success' } else { return '' }
    },
    hasLiabilityInsurance: function () {
      if (this.liabilityInsurance === 0) { return 'No' } else if (this.liabilityInsurance === 1) { return 'Yes' } else { return 'In Review' }
    },
    hasLiabilityInsuranceClass: function () {
      if (this.liabilityInsurance === 0) { return 'text-danger' } else if (this.liabilityInsurance === 1) { return 'text-success' } else { return '' }
    }
  }
}
</script>

<style>
#insurance span {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/modalInsurance.vue